export function createSelection({
  tableDataLength,
  defaultSelectedRowKeys = [],
  reserveSelection,
  selection = []
}) {
  const isAllSelected = tableDataLength > 0 && defaultSelectedRowKeys.length === tableDataLength
  const _selection = reserveSelection ? new Set([...selection, ...defaultSelectedRowKeys]) : new Set([...defaultSelectedRowKeys])
  return {
    isAllSelected,
    selectOnIndeterminate: !!_selection.size && !isAllSelected,
    selection: _selection
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/store/config/selection.js